var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 21.5,
    rx: 4.75,
    stroke: "#DADADA",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4313 10.825C17.4313 10.825 14.6581 14.65 11.2156 14.65C7.77313 14.65 5 10.825 5 10.825C5 10.825 7.77313 7 11.2156 7C14.6581 7 17.4313 10.825 17.4313 10.825Z",
    stroke: "#1D64C8",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2157 12.7376C12.272 12.7376 13.1282 11.8813 13.1282 10.8251C13.1282 9.76885 12.272 8.9126 11.2157 8.9126C10.1595 8.9126 9.30322 9.76885 9.30322 10.8251C9.30322 11.8813 10.1595 12.7376 11.2157 12.7376Z",
    stroke: "#1D64C8",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/PreviewIcon.d9d54e16397159e2bac07c6cb49ab1ec.svg";
export { ForwardRef as ReactComponent };